import Wrapper from './Wrapper.vue';

const Jobs = () => import('./_views/jobs');
const Job = () => import('./_views/job');

const parentRouteConfig = {
  name: 'Jobs',
  to: {
    name: 'jobs',
    query: {
      suffix: '',
      pageNum: '1',
    },
  },
};

export default [
  {
    path: '/jobs',
    component: Wrapper,
    children: [
      {
        path: '',
        name: 'jobs',
        component: Jobs,
        meta: {
          title: 'Jobs',
          navigation: {
            position: 3,
            name: 'Jobs',
            icon: 'work',
            specialQueries: ['suffix'],
            to: {
              name: 'jobs',
              query: {
                suffix: '',
                pageNum: '1',
              },
            },
          },
        },
      },
      {
        path: ':id',
        name: 'job',
        component: Job,
        meta: {
          title: 'Job Details',
          enableSetSuffix: true,
          parent: parentRouteConfig,
        },
      },
    ],
  },
];
